import { render } from "./JointGroupedFiles.vue?vue&type=template&id=6bf7b289"
import script from "./JointGroupedFiles.vue?vue&type=script&lang=js"
export * from "./JointGroupedFiles.vue?vue&type=script&lang=js"

import "./JointGroupedFiles.vue?vue&type=style&index=0&id=6bf7b289&lang=scss"

import exportComponent from "/home/admin/swarm-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__